import { ISODateTime } from '../../admin/types/date';

export type NotificationDeliveryIndexView = {
    id: number;
    recipient_id: number;
    read_at: ISODateTime;
    created_at: ISODateTime;
    notification: NotificationsIndexView;
    notification_category: NotificationCategory | null;
    important: boolean;
    token: NotificationDeliveryToken;
    test_delivery: boolean;
};

export type NotificationDeliveryToken = string;

export enum NotificationDeliveryStatus {
    PENDING_SCHEDULE = 'pending_schedule',
    SCHEDULED = 'scheduled',
    SENT = 'sent',
    CANCELLED = 'cancelled',
}

export type NotificationsIndexView = {
    id: number;
    title: string;
    content: string;
    scheduled_at: ISODateTime;
    thumbnail: string;
    delivery_status: NotificationDeliveryStatus;
};

export type NotificationCategory = {
    id: number;
    name: NotificationCategoryNames;
};

export enum NotificationCategoryNames {
    IMPORTANT = '重要',
    RESERVATION = '予約受付',
    OTHER = 'その他',
}
